export default "__VITE_ASSET__BWvNCuhp__"